import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { api, formatApiError } from "@/lib/api";

const EMPTY = { label: "", check_in: "", check_out: "", max_seats: 10, seats_taken: 0, status: "waitlist", note: "" };

function Row({ r, onSaved }) {
  const [f, setF] = useState(r);
  const set = (k, num) => (e) => setF({ ...f, [k]: num ? Number(e.target.value) : e.target.value });
  const save = async () => {
    const { id, seats_left, created_at, updated_at, ...body } = f;
    try { await (id ? api.put(`/admin/retreats/${id}`, body) : api.post("/admin/retreats", body)); toast.success("Saved"); onSaved(); }
    catch (e) { toast.error(formatApiError(e)); }
  };
  const del = () => window.confirm("Delete this retreat group?") && api.delete(`/admin/retreats/${r.id}`).then(onSaved);
  return (
    <div className="bg-white rounded-2xl border border-[#0B2A4A]/10 p-4 grid sm:grid-cols-2 lg:grid-cols-[1.2fr_1fr_1fr_90px_90px_1fr_auto] gap-2 items-end" data-testid="retreat-admin-row">
      <label className="text-xs text-slate-500">Name<Input value={f.label} onChange={set("label")} data-testid="retreat-label" /></label>
      <label className="text-xs text-slate-500">Check in (Sun)<Input type="date" value={f.check_in} onChange={set("check_in")} data-testid="retreat-check-in" /></label>
      <label className="text-xs text-slate-500">Check out (Mon)<Input type="date" value={f.check_out} onChange={set("check_out")} data-testid="retreat-check-out" /></label>
      <label className="text-xs text-slate-500">Max<Input type="number" min={1} max={50} value={f.max_seats} onChange={set("max_seats", true)} data-testid="retreat-max" /></label>
      <label className="text-xs text-slate-500">Taken<Input type="number" min={0} max={50} value={f.seats_taken} onChange={set("seats_taken", true)} data-testid="retreat-taken" /></label>
      <label className="text-xs text-slate-500">Status
        <select value={f.status} onChange={set("status")} className="w-full h-9 rounded-md border px-2 text-sm" data-testid="retreat-status-select">
          <option value="open">Now booking</option><option value="waitlist">Opening soon / waitlist</option><option value="full">Full</option>
        </select>
      </label>
      <div className="flex gap-2">
        <button onClick={save} className="rounded-lg bg-[#0B2A4A] text-white px-3 py-2 text-xs font-semibold" data-testid="retreat-save-btn">Save</button>
        {r.id && <button onClick={del} className="rounded-lg border px-3 py-2 text-xs text-rose-600" data-testid="retreat-delete-btn">Delete</button>}
      </div>
      <label className="text-xs text-slate-500 sm:col-span-2 lg:col-span-7">Public note<Input value={f.note} onChange={set("note")} maxLength={300} data-testid="retreat-note" /></label>
    </div>
  );
}

export function RetreatsAdmin() {
  const [rows, setRows] = useState(null);
  const [adding, setAdding] = useState(false);
  const load = () => api.get("/admin/retreats").then((r) => { setRows(r.data); setAdding(false); }).catch(() => setRows([]));
  useEffect(() => { load(); }, []);
  if (!rows) return null;
  return (
    <div className="flex flex-col gap-3" data-testid="retreats-admin">
      <p className="text-sm text-slate-600">Retreat groups shown on the website. Update "Taken" as students pay; the site shows seats left and switches to Full automatically.</p>
      {rows.map((r) => <Row key={r.id} r={r} onSaved={load} />)}
      {adding ? <Row r={EMPTY} onSaved={load} /> : <button onClick={() => setAdding(true)} className="self-start rounded-xl border px-4 py-2 text-sm font-semibold" data-testid="retreat-add-btn">+ Add retreat group</button>}
    </div>
  );
}
